import type { RoundScore } from '../services/round-scores';

/**
 * A team manager's athletes in the order they are shown, by the name on the row.
 *
 * The server sends them in start-list order — surname first
 * (`CompetitionParticipant.ordered`), which is what a judge's table and the
 * panel's board want. A manager's surfaces show `full_name` ("Ada Lovelace"), so
 * ordering by surname there reads as no order at all.
 *
 * Shared by the table and the athlete page because the page's previous/next —
 * the arrows and the swipe — have to walk the list in the order the reader just
 * saw it in.
 *
 * `localeCompare` rather than `<`: these are Italian names, and a list that puts
 * "Zanotti" before "Àvila" is wrong in the only way anybody would notice.
 */
export function byAthleteName(scores: RoundScore[]): RoundScore[] {
  return [...scores].sort((a, b) =>
    (a.full_name ?? '').localeCompare(b.full_name ?? '', undefined, { sensitivity: 'base' })
  );
}
